module.exports = __webpack_public_path__ + "static/grid-55ed5dcf1e10ea136e14d958e9c36449.mp4";